import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes, InsightContext } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const TablesContext = React.createContext(null);

export const TableValueType = {
    Local: 0,
    Sap: 1
}

const { Provider } = TablesContext;
export const TablesProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { trackError } = useContext(InsightContext);
    const [state, setState] = useAggregatedState({
        tables: [],
        tableValues: [],
        selectedTableIndex: -1
    });

    // table names here
    // todo: define all the table names here
    const responsibilityCenterTableName = 'Responsibility Centers';
    const investmentMixesTableName = 'Investment Mixes';
    const targetRegionsTableName = 'Target Regions';
    const projectApprovalsTableName = 'Project Approvals';
    const projectPhasesTableName = 'Project Phases';
    const projectLivesTableName = 'Project Lives';
    const milestonePhasesTableName = 'Milestone Phases';
    const milestoneStatesTableName = 'Milestone States';
    const projectStatesTableName = 'Project States';
    const portfolioMixesTableName = 'Portfolio Mixes';
    const releaseDatesTableName = 'Release Dates';
    const controllingAreasTableName = 'Controlling Areas';

    const [isLoadingTableDefs, setIsLoadingTableDefs] = useState(false);
    const getTableDefinitions = async (valueType) => {

        try {

            setIsLoadingTableDefs(true);
            const r = await fetchAuthorized(ApiRoutes.Dimension.GetTableDefinitions(),
                {
                    method: HttpMethods.GET
                });

            const tables = await r.json();
            setState({ tables });
            setIsLoadingTableDefs(false);
        } catch (e) {
            console.log(e);
            trackError(e);
            setIsLoadingTableDefs(false);
        }
    }

    const [isLoadingTableValues, setIsLoadingTableValues] = useState(false);
    const getTableValues = async (selectedTableIndex) => {
        try {
            setIsLoadingTableValues(true);
            const table = state.tables[selectedTableIndex];
            const tableValue = table.name;
            const r = await fetchAuthorized(ApiRoutes.Dimension.GetTableValues({ table: tableValue }),
                {
                    method: HttpMethods.GET
                });

            var tableValues = await r.json();
            var currentValues = tableValues.items ?? Array[0];
            tableValues = currentValues;

            setState({ tableValues });
            setIsLoadingTableValues(false);

        } catch (e) {
            console.log(e);
            trackError(e);
            setIsLoadingTableValues(false);
        }
    }

    const [isAddingValue, setIsAddingValue] = useState(false);
    const addTableValue = async (data) => {
        try {
            setIsAddingValue(true);

            switch (data.tableName){
                case 'Domains':
                    await callDomainCreateApi(data);
                    break;
                case 'Digitals':
                    await callDigitalCreateApi(data);
                    break;
                case targetRegionsTableName:
                    await callTargetCreateApi(data);
                    break;
                case 'Customers':
                    //await callCustomerCreateApi(data);
                    break;
                case 'Goals':
                    await callGoalCreateApi(data);
                    break;
                case 'Natures':
                    await callNatureCreateApi(data);
                    break;
                case investmentMixesTableName:
                    await callInvestmentMixCreateApi(data);
                    break;
                case 'Mandatories':
                    await callMandatoryCreateApi(data);
                    break;
                case 'Methodologies':
                    await callMethodologyCreateApi(data);
                    break;
                case projectApprovalsTableName:
                    await callProjectApprovalCreateApi(data);
                    break;
                case projectPhasesTableName:
                    await callProjectPhaseCreateApi(data);
                    break;
                case projectLivesTableName:
                    await callProjectLifeCreateApi(data);
                    break;
                case 'Rebillings':
                    await callRebillingCreateApi(data);
                    break;
                case releaseDatesTableName:
                    await callReleaseDateCreateApi(data);
                    break;
                case controllingAreasTableName:
                    await callControllingAreaCreateApi(data);
                    break;
                case 'SubCustomers':
                    await callSubCustomerCreateApi(data);
                    break;
                case 'SubDomains':
                    await callSubDomainCreateApi(data);
                    break;
                case 'Timings':
                    await callTimingCreateApi(data);
                    break;
                case milestonePhasesTableName:
                    await callMilestonePhaseCreateApi(data);
                    break;
                case milestoneStatesTableName:
                    await callMilestoneStatusCreateApi(data);
                    break;
                case projectStatesTableName:
                    await callProjectStatusCreateApi(data);
                    break;
                case portfolioMixesTableName:
                    await callPortfolioMixCreateApi(data);
                    break;
                case 'Priorities':
                    await callPriorityCreateApi(data);
                    break;
                case responsibilityCenterTableName:
                    await callResponsibilityCenterCreateApi(data);
                    break;
                default:
                    break;
            }
            
            setIsAddingValue(false);

        }
        catch (e){
            console.log(e);
            trackError(e);
            setIsAddingValue(false);
        }
    }

    const [isUpdatingValue, setIsUpdatingValue] = useState(false);
    const updateTableValue = async (data, completed) => {
        try {
            setIsUpdatingValue(true);

            switch (data.tableName){
                case 'Domains':
                    await callDomainUpdateApi(data);
                    break;
                case 'Digitals':
                    await callDigitalUpdateApi(data);
                    break;
                case targetRegionsTableName:
                    await callTargetUpdateApi(data);
                    break;
                case 'Customers':
                    //await callCustomerUpdateApi(data);
                    break;
                case 'Goals':
                    await callGoalUpdateApi(data);
                    break;
                case 'Natures':
                    await callNatureUpdateApi(data);
                    break;
                case investmentMixesTableName:
                    await callInvestmentMixUpdateApi(data);
                    break;
                case 'Mandatories':
                    await callMandatoryUpdateApi(data);
                    break;
                case 'Methodologies':
                    await callMethodologyUpdateApi(data);
                    break;
                case projectApprovalsTableName:
                    await callProjectApprovalUpdateApi(data);
                    break;
                case projectPhasesTableName:
                    await callProjectPhaseUpdateApi(data);
                    break;
                case projectLivesTableName:
                    await callProjectLifeUpdateApi(data);
                    break;
                case 'Rebillings':
                    await callRebillingUpdateApi(data);
                    break;
                case releaseDatesTableName:
                    await callReleaseDateUpdateApi(data);
                    break;
                case controllingAreasTableName:
                    await callControllingAreaUpdateApi(data);
                    break;
                case 'SubCustomers':
                    await callSubCustomerUpdateApi(data);
                    break;
                case 'SubDomains':
                    await callSubDomainUpdateApi(data);
                    break;
                case 'Timings':
                    await callTimingUpdateApi(data);
                    break;
                case milestonePhasesTableName:
                    await callMilestonePhaseUpdateApi(data);
                    break;
                case milestoneStatesTableName:
                    await callMilestoneStatusUpdateApi(data);
                    break;
                case projectStatesTableName:
                    await callProjectStatusUpdateApi(data);
                    break;
                case portfolioMixesTableName:
                    await callPortfolioMixUpdateApi(data);
                    break;
                case 'Priorities':
                    await callPriorityUpdateApi(data);
                    break;
                case responsibilityCenterTableName:
                    await callResponsibilityCenterUpdateApi(data);
                    break;
                default:
                    break;
            }
            
            setIsUpdatingValue(false);
        }
        catch (e){
            console.log(e);
            trackError(e);
            setIsUpdatingValue(false);
        }
    }

    const [isDeletingValue, setIsDeletingValue] = useState(false);
    const deleteTableValue = async (oldTable, valueId) => {
        try {
            setIsDeletingValue(true);

            switch (oldTable.name){
                case 'Domains':
                    await callDomainDeleteApi(oldTable, valueId);
                    break;
                case 'Digitals':
                    await callDigitalDeleteApi(oldTable, valueId);
                    break;
                case targetRegionsTableName:
                    await callTargetDeleteApi(oldTable, valueId);
                    break;
                case 'Customers':
                    //await callCustomerDeleteApi(oldTable, valueId);
                    break;
                case 'Goals':
                    await callGoalDeleteApi(oldTable, valueId);
                    break;
                case 'Natures':
                    await callNatureDeleteApi(oldTable, valueId);
                    break;
                case investmentMixesTableName:
                    await callInvestmentMixDeleteApi(oldTable, valueId);
                    break;
                case 'Mandatories':
                    await callMandatoryDeleteApi(oldTable, valueId);
                    break;
                case 'Methodologies':
                    await callMethodologyDeleteApi(oldTable, valueId);
                    break;
                case projectApprovalsTableName:
                    await callProjectApprovalDeleteApi(oldTable, valueId);
                    break;
                case projectPhasesTableName:
                    await callProjectPhaseDeleteApi(oldTable, valueId);
                    break;
                case projectLivesTableName:
                    await callProjectLifeDeleteApi(oldTable, valueId);
                    break;
                case 'Rebillings':
                    await callRebillingDeleteApi(oldTable, valueId);
                    break;
                case releaseDatesTableName:
                    await callReleaseDateDeleteApi(oldTable, valueId);
                    break;
                case controllingAreasTableName:
                    await callControllingAreaDeleteApi(oldTable, valueId);
                    break;
                case 'SubCustomers':
                    await callSubCustomerDeleteApi(oldTable, valueId);
                    break;
                case 'SubDomains':
                    await callSubDomainDeleteApi(oldTable, valueId);
                    break;
                case 'Timings':
                    await callTimingDeleteApi(oldTable, valueId);
                    break;
                case milestonePhasesTableName:
                    await callMilestonePhaseDeleteApi(oldTable, valueId);
                    break;
                case milestoneStatesTableName:
                    await callMilestoneStatusDeleteApi(oldTable, valueId);
                    break;
                case projectStatesTableName:
                    await callProjectStatusDeleteApi(oldTable, valueId);
                    break;
                case portfolioMixesTableName:
                    await callPortfolioMixDeleteApi(oldTable, valueId);
                    break;
                case 'Priorities':
                    await callPriorityDeleteApi(oldTable, valueId);
                    break;
                case responsibilityCenterTableName:
                    await callResponsibilityCenterDeleteApi(oldTable, valueId);
                    break;
                default:
                    break;
            }
            
            setIsDeletingValue(false);
        }
        catch (e){
            console.log(e);
            trackError(e);
            setIsDeletingValue(false);
        }
    }

    const setSelectedTableIndex = (index) => {
        setState({ selectedTableIndex: index });
    }

    const callDomainCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddDomains(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Domains');
        tableValues.push({ id: tableValue.id, tableName: 'Domains', value: tableValue.title });

        table.childValues.push({ id: tableValue.id, tableName: 'Domains', value: tableValue.title });

        //add to subDomain values:
        const subDomainTable = tables.find(x => x.name === 'SubDomains');
        subDomainTable.relatedTable.childValues.push({ id: tableValue.id, tableName: 'Domains', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callDigitalCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddDigitals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Digitals', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Digitals');
        table.childValues.push({ id: tableValue.id, tableName: 'Digitals', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callTargetCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddTargets(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: targetRegionsTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === targetRegionsTableName);
        table.childValues.push({ id: tableValue.id, tableName: targetRegionsTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callCustomerCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddCustomers(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Customers');
        tableValues.push({ id: tableValue.id, tableName: 'Customers', value: tableValue.title });

        table.childValues.push({ id: tableValue.id, tableName: 'Customers', value: tableValue.title });

        //add to sucustomer values:
        const subCustomerTable = tables.find(x => x.name === 'SubCustomers');
        subCustomerTable.relatedTable.childValues.push({ id: tableValue.id, tableName: 'Customers', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callGoalCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddGoals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Goals', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Goals');
        table.childValues.push({ id: tableValue.id, tableName: 'Goals', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callNatureCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddNatures(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Natures', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Natures');
        table.childValues.push({ id: tableValue.id, tableName: 'Natures', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callMandatoryCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddMandatories(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Mandatories', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Mandatories');
        table.childValues.push({ id: tableValue.id, tableName: 'Mandatories', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callInvestmentMixCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddInvestmentMixes(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: investmentMixesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === investmentMixesTableName);
        table.childValues.push({ id: tableValue.id, tableName: investmentMixesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callMethodologyCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddMethodologies(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Methodologies', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Methodologies');
        table.childValues.push({ id: tableValue.id, tableName: 'Methodologies', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callProjectApprovalCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddProjectApprovals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: projectApprovalsTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectApprovalsTableName);
        table.childValues.push({ id: tableValue.id, tableName: projectApprovalsTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callProjectPhaseCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddProjectPhases(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: projectPhasesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectPhasesTableName);
        table.childValues.push({ id: tableValue.id, tableName: projectPhasesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callProjectLifeCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddProjectLives(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: projectLivesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectLivesTableName);
        table.childValues.push({ id: tableValue.id, tableName: projectLivesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callRebillingCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddRebillings(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0, CustomId: data.customId })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Rebillings', value: tableValue.title, customId: tableValue.customId });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Rebillings');
        table.childValues.push({ id: tableValue.id, tableName: 'Rebillings', value: tableValue.title, customId: tableValue.customId });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callReleaseDateCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddReleaseDates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0, CustomId: data.customId })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: releaseDatesTableName, value: tableValue.title, customId: tableValue.customId });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === releaseDatesTableName);
        table.childValues.push({ id: tableValue.id, tableName: releaseDatesTableName, value: tableValue.title, customId: tableValue.customId });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callControllingAreaCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddControllingAreas(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0, Code: data.code })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: controllingAreasTableName, value: tableValue.title, code: tableValue.code });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === controllingAreasTableName);
        table.childValues.push({ id: tableValue.id, tableName: controllingAreasTableName, value: tableValue.title, code: tableValue.code });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callSubCustomerCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddSubCustomers(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0, CustomerId: data.customerName })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        const newRelatedValuesIds = [tableValue.customerId]; //the new customer id shall be rendered
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'SubCustomers');

        tableValues.push({ id: tableValue.id, tableName: 'SubCustomers', value: tableValue.title, customerName: tableValue.customerName, customerId: tableValue.customerId, relatedValuesIds: newRelatedValuesIds });

        table.childValues.push({ id: tableValue.id, tableName: 'SubCustomers', value: tableValue.title, customerName: tableValue.customerName, customerId: tableValue.customerId, relatedValuesIds: newRelatedValuesIds });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callSubDomainCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddSubDomains(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0, DomainId: data.domainName })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        const newRelatedValuesIds = [tableValue.domainId]; //the new domain id shall be rendered
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'SubDomains');

        tableValues.push({ id: tableValue.id, tableName: 'SubDomains', value: tableValue.title, domainName: tableValue.domainName, domainId: tableValue.domainId, relatedValuesIds: newRelatedValuesIds });

        table.childValues.push({ relatedValuesIds: newRelatedValuesIds, id: tableValue.id, tableName: 'SubDomains', value: tableValue.title, domainName: tableValue.domainName, domainId: tableValue.domainId });

        tables[tables.findIndex(x => x.name === 'SubDomains')] = table;
        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callTimingCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddTimings(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Timings', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Timings');
        table.childValues.push({ id: tableValue.id, tableName: 'Timings', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callMilestonePhaseCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddMilestonePhases(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: milestonePhasesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === milestonePhasesTableName);
        table.childValues.push({ id: tableValue.id, tableName: milestonePhasesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callMilestoneStatusCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddMilestoneStates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: milestoneStatesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === milestoneStatesTableName);
        table.childValues.push({ id: tableValue.id, tableName: milestoneStatesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callProjectStatusCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddProjectStates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: projectStatesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectStatesTableName);
        table.childValues.push({ id: tableValue.id, tableName: projectStatesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callPortfolioMixCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddPortfolioMixes(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: portfolioMixesTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === portfolioMixesTableName);
        table.childValues.push({ id: tableValue.id, tableName: portfolioMixesTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callPriorityCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddPriorities(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: 'Priorities', value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Priorities');
        table.childValues.push({ id: tableValue.id, tableName: 'Priorities', value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }
    const callResponsibilityCenterCreateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.AddResponsibilityCenters(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: 0 })
            });

        const tableValue = await result.json();
        const tableValues = [].concat(state.tableValues);
        tableValues.push({ id: tableValue.id, tableName: responsibilityCenterTableName, value: tableValue.title });
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === responsibilityCenterTableName);
        table.childValues.push({ id: tableValue.id, tableName: responsibilityCenterTableName, value: tableValue.title });

        setState({ tables, tableValues });
        setIsAddingValue(false);
    }

    const callDomainDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteDomains(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Domains');
        table.childValues = table.childValues.filter(x => x.id !== valueId);
        
        setState({ table, tableValues });
    }
    const callDigitalDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteDigitals(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Digitals');
        table.childValues = table.childValues.filter(x => x.valueId !== valueId);

        setState({ tableValues });
    }
    const callTargetDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteTargets(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === targetRegionsTableName);
        table.childValues = table.childValues.filter(x => x.valueId !== valueId);

        setState({ tableValues });
    }
    const callCustomerDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteCustomers(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Customers');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ table, tableValues });
    }
    const callGoalDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteGoals(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Goals');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callNatureDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteNatures(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Natures');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callInvestmentMixDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteInvestmentMixes(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === investmentMixesTableName);
        table.childValues = table.childValues.filter(x => x.valueId !== valueId);

        setState({ tableValues });
    }
    const callMandatoryDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteMandatories(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Mandatories');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callMethodologyDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteMethodologies(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Methodologies');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callProjectApprovalDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteProjectApprovals(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectApprovalsTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callProjectPhaseDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteProjectPhases(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectPhasesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callProjectLifeDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteProjectLives(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectLivesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callRebillingDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteRebillings(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Rebillings');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callReleaseDateDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteReleaseDates(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === releaseDatesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callControllingAreaDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteControllingAreas(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === controllingAreasTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callSubCustomerDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteSubCustomers(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '', CustomerName: null })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'SubCustomers');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callSubDomainDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteSubDomains(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'SubDomains');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callTimingDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteTimings(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Timings');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callMilestonePhaseDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteMilestonePhases(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === milestonePhasesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callMilestoneStatusDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteMilestoneStates(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === milestoneStatesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callProjectStatusDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteProjectStates(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === projectStatesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callPortfolioMixDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeletePortfolioMixes(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === portfolioMixesTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callPriorityDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeletePriorities(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === 'Priorities');
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }
    const callResponsibilityCenterDeleteApi = async (oldTable, valueId) => {
        const r = await fetchAuthorized(ApiRoutes.Dimension.DeleteResponsibilityCenters(),
            {
                method: HttpMethods.DELETE,
                body: JSON.stringify({ Id: valueId, Title: '' })
            });

        const tableValues = [].concat(state.tableValues.filter(x => x.id !== valueId));
        const tables = [].concat(state.tables);
        const table = tables.find(x => x.name === responsibilityCenterTableName);
        table.childValues = table.childValues.filter(x => x.id !== valueId);

        setState({ tableValues });
    }

    const callDomainUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateDomains(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });


        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Domains');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Domains', value: tableValue.title };

        table.childValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Domains', value: tableValue.title };

        const subDomainTable = tables.find(x => x.name === 'SubDomains');
        subDomainTable.relatedTable.childValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Domains', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callDigitalUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateDigitals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Digitals');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Digitals', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callTargetUpdateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateTargets(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });
        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === targetRegionsTableName);
        
        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: targetRegionsTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callCustomerUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateCustomers(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Customers');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Customers', value: tableValue.title };

        table.childValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Customers', value: tableValue.title };

        const subCustomerTable = tables.find(x => x.name === 'SubCustomers');
        subCustomerTable.relatedTable.childValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Customers', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callGoalUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateGoals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Goals');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Goals', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callNatureUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateNatures(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Natures');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Natures', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callInvestmentMixUpdateApi = async (data) => {
        let result;
        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateInvestmentMixes(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === investmentMixesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: investmentMixesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callMandatoryUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateMandatories(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Mandatories');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Mandatories', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callMethodologyUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateMethodologies(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Methodologies');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Methodologies', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callProjectApprovalUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateProjectApprovals(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === projectApprovalsTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: projectApprovalsTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callProjectPhaseUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateProjectPhases(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === projectPhasesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: projectPhasesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callProjectLifeUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateProjectLives(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === projectLivesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: projectLivesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callRebillingUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateRebillings(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id, CustomId: data.customId })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Rebillings');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Rebillings', value: tableValue.title, customId: tableValue.customId };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callReleaseDateUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateReleaseDates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id, CustomId: data.customId })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === releaseDatesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: releaseDatesTableName, value: tableValue.title, customId: tableValue.customId };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callControllingAreaUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateControllingAreas(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id, Code: data.code })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === controllingAreasTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: controllingAreasTableName, value: tableValue.title, code: tableValue.code };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callSubCustomerUpdateApi = async (data) => {
        let result;

        if (isNaN(data.customerName)) {
            result = await fetchAuthorized(ApiRoutes.Dimension.UpdateSubCustomers(),
                {
                    method: HttpMethods.POST,
                    body: JSON.stringify({ Title: data.value, Id: data.id, CustomerName: data.customerName })
                });
        } else {
            result = await fetchAuthorized(ApiRoutes.Dimension.UpdateSubCustomers(),
                {
                    method: HttpMethods.POST,
                    body: JSON.stringify({ Title: data.value, Id: data.id, CustomerId: data.customerName })
                });
        }
        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'SubCustomers');
        const newRelatedValuesIds = [tableValue.customerId]; //the new customer id shall be rendered

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, relatedValuesIds: newRelatedValuesIds, tableName: 'SubCustomers', value: tableValue.title, customerName: tableValue.customerName, customerId: tableValue.customerId };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callSubDomainUpdateApi = async (data) => {
        let result;
        if (isNaN(data.domainName)) {
            result = await fetchAuthorized(ApiRoutes.Dimension.UpdateSubDomains(),
                {
                    method: HttpMethods.POST,
                    body: JSON.stringify({ Title: data.value, Id: data.id, DomainName: data.domainName })
                });
        }
        else {
            result = await fetchAuthorized(ApiRoutes.Dimension.UpdateSubDomains(),
                {
                    method: HttpMethods.POST,
                    body: JSON.stringify({ Title: data.value, Id: data.id, DomainId: data.domainName })
                });
        }

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'SubDomains');
        const newRelatedValuesIds = [tableValue.domainId]; //the new domain id shall be rendered

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, relatedValuesIds: newRelatedValuesIds, tableName: 'SubDomains', value: tableValue.title, domainName: tableValue.domainName, domainId: tableValue.domainId };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callTimingUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateTimings(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Timings');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Timings', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callMilestonePhaseUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateMilestonePhases(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === milestonePhasesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: milestonePhasesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callMilestoneStatusUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateMilestoneStates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === milestoneStatesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: milestoneStatesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callProjectStatusUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateProjectStates(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === projectStatesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: projectStatesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callPortfolioMixUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdatePortfolioMixes(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === portfolioMixesTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: portfolioMixesTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callPriorityUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdatePriorities(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === 'Priorities');

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: 'Priorities', value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }
    const callResponsibilityCenterUpdateApi = async (data) => {
        let result;

        result = await fetchAuthorized(ApiRoutes.Dimension.UpdateResponsibilityCenters(),
            {
                method: HttpMethods.POST,
                body: JSON.stringify({ Title: data.value, Id: data.id })
            });

        const tableValue = await result.json();
        const tables = [].concat(state.tables);
        const tableValues = [].concat(state.tableValues);
        const table = tables.find(x => x.name === responsibilityCenterTableName);

        // update the old value
        tableValues[tableValues.findIndex(x => x.id === data.id)] = { id: tableValue.id, tableName: responsibilityCenterTableName, value: tableValue.title };

        setState({ table, tableValues });
        setIsUpdatingValue(false);
    }

    return (
        <Provider value={{
            state,
            isLoadingTableDefs,
            getTableDefinitions,
            isLoadingTableValues,
            getTableValues,
            isAddingValue,
            addTableValue,
            isUpdatingValue,
            updateTableValue,
            isDeletingValue,
            deleteTableValue,
            setSelectedTableIndex
        }}>
            {props.children}
        </Provider>
    );
}